export const iconFontAwesomeDevicesHardwareSatelliteDish = (
	<i className="fa-solid fa-satellite-dish"></i>
);
